import { render, staticRenderFns } from "./com-action-button.vue?vue&type=template&id=1912e037&scoped=true"
import script from "./com-action-button.vue?vue&type=script&lang=js"
export * from "./com-action-button.vue?vue&type=script&lang=js"
import style0 from "./com-action-button.vue?vue&type=style&index=0&id=1912e037&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1912e037",
  null
  
)

export default component.exports